import { Line } from "./BaseCharts";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default() {
        return [];
      }
    },
    lastUpdate: {
      type: Array,
      default() {
        return [];
      }
    },
    bdColor: {
      type: String,
      default() {
        return [];
      }
    },
    xAxesColor: {
      type: String,
      default() {
        return 'rgba(0, 0, 0, 0.1)';
      }
    },
    yAxesColor: {
      type: String,
      default() {
        return 'rgba(0, 0, 0, 0.1)';
      }
    },
    xAxesLine: {
      type: Boolean,
      default() {
        return true;
      }
    },
    yAxesLine: {
      type: Boolean,
      default() {
        return true;
      }
    },
    numData: {
      type: Array,
      default() {
        return [];
      }
    },
    timeout:{
      type:Number,
      default:1
    },
    tooltipsCompanyText:{
      type:Boolean,
      default:false
    },
    unitLabel:{
      type:String,
      default:''
    },
    commaY:{
      type:Boolean,
      default:false
    }
  },
  mounted() {
    var unitLabel = this.unitLabel
    var commaY = this.commaY
    var lastUpdate = this.lastUpdate
    setTimeout(() => {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: this.bdColor,
              data: this.numData,
              fill:false,
              borderColor:this.bdColor,
              borderWidth:2
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
            callbacks: {
              title: function(tooltipItems, data) {
                return'';
              },
              label: function(tooltipItem, data) {
                var label = data.labels[tooltipItem.datasetIndex] || "";
                var num = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                var numComma = 0
                  if (num > -1) {
                    var numComma = num
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                  }
                  // let companyText = (num > 1 && tooltipsCompanyText === true)?'companies':(num <= 1 && tooltipsCompanyText === true)?'company':''
                
                if (lastUpdate.length > 0) {
                  label = lastUpdate[tooltipItem.index] + ": " + numComma +' '+ unitLabel
                }else{
                  label = data.labels[tooltipItem.index] + ": " + numComma +' '+ unitLabel
                }
                return label;
              }
            },
            enabled:true
          },
          scales: {
              xAxes: [ {  
                  gridLines: {
                      display: true,
                      color: this.xAxesColor,
                      lineWidth:1,
                  },    
              }],
              yAxes: [{
                  gridLines: {
                      display: true,
                      color: this.yAxesColor,
                      lineWidth:1
                  },
                  ticks: {
                    precision: 0,
                    callback: function(value, index, values) {
                      return (commaY === true)?value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"):value
                    }
                  },
                }]
  
            },
        }
      );},this.timeout*1000);
  },
};
